import type { FormField } from '@cli-types/core-engine/schema.js'
import { SEARCHABLE_FORM_FIELD_TYPES } from '@cli-constants/schema-codegen.js'

export function getSearchableSubmissionFields(fields: FormField[]): string[] {
  return Array.from(
    new Set(
      fields
        .filter((field): field is FormField & { name: string } => Boolean(field.name))
        .filter((field) => SEARCHABLE_FORM_FIELD_TYPES.has(field.type))
        .map((field) => field.name)
    )
  )
}
